export default "__VITE_ASSET__5zqgfuEX__"